import * as __SNOWPACK_ENV__ from '../../_snowpack/env.js';

/**
 * Responsible of checking the running app version against the remote
 * version and notifying users when there are new versions available
 */
import React, { useState, useEffect } from '../../_snowpack/pkg/react.js';
import { colors } from '../css/index.js';
import styled, { css } from '../../_snowpack/pkg/styled-components.js';
import WeirdFlex from '../images/illustrations/new-app-version.svg';
const Toast = styled.div.withConfig({
  displayName: "app-version__Toast",
  componentId: "sc-1j2rcqd-0"
})(({
  theme
}) => css(["z-index:", ";right:0;position:fixed;bottom:0;left:0;padding:0 100px;width:100%;background:", ";"], theme.zIndex.appVersionToast, colors.glacierLighter));
const Inner = styled.div.withConfig({
  displayName: "app-version__Inner",
  componentId: "sc-1j2rcqd-1"
})(["max-width:1060px;margin:0 auto;position:relative;border:1px solid transparent;p{font-size:15px;color:#4c776d;padding-left:100px;strong{padding-right:15px;font-size:16px;}button{appearance:none;border:none;padding:0;display:inline-block;background:transparent;text-decoration:underline;margin-left:5px;color:inherit;cursor:pointer;font-size:inherit;&:hover{text-decoration:none;}}}"]);
const Illustration = styled.div.withConfig({
  displayName: "app-version__Illustration",
  componentId: "sc-1j2rcqd-2"
})(["width:70px;position:absolute;bottom:-1px;overflow:hidden;img{margin-bottom:-30px;width:100%;}"]);
export default /*#__PURE__*/React.memo(function AppVersionManager() {
  const [newVersionAvailable, setNewVersionAvailable] = useState(false);
  useEffect(() => {
    // No need to check in local development
    if (window.location.hostname === 'localhost') {
      return;
    }

    async function getRemoteVersion() {
      try {
        const versionInfo = await fetch('/version.json').then(r => r.json());

        if (versionInfo !== null && versionInfo !== void 0 && versionInfo.id) {
          const currentVersion = __SNOWPACK_ENV__.SNOWPACK_PUBLIC_PIM_VERSION;

          if (currentVersion !== versionInfo.id) {
            setNewVersionAvailable(true);
          }
        }
      } catch (e) {
        console.error(e);
      }
    } // Let the app settle before getting the version initially


    setTimeout(getRemoteVersion, 5000);
    const interval = setInterval(getRemoteVersion, 1000 * 60 * 5);
    return () => clearTimeout(interval);
  }, []);

  if (!newVersionAvailable) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Toast, null, /*#__PURE__*/React.createElement(Inner, null, /*#__PURE__*/React.createElement(Illustration, null, /*#__PURE__*/React.createElement("img", {
    src: WeirdFlex,
    alt: "Weird man flexing"
  })), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "*Hnnnng*"), "Now that I got your attention, there is a brand new version of Crystallize PIM out. Refresh your browser to get it.", /*#__PURE__*/React.createElement("button", {
    onClick: () => setNewVersionAvailable(false)
  }, "Snooze"))));
});